'use strict';

var template = require('../../templates/settings/Notifications.ejs');
var FormView = require('commons/views/Form');
var modal    = require('helpers/modal');

module.exports = FormView.extend({

    initialize: function(options) {
        var self = this;

        self.options = _.defaults(options || {}, {template: template});

        return FormView.prototype.initialize.apply(self, [self.options]);
    },

    save: function(ev) {
        FormView.prototype.save.apply(this, [ev]).then(function() {
            modal.showAlertSuccess('Settings have been saved');
        });
        return false;
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/Notifications.js